export function on() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
    }
    var reducer = args.pop();
    var types = args.reduce(function (result, creator) { return result.concat([creator.type]); }, []);
    return { reducer: reducer, types: types };
}
export function reducer(initialState) {
    var ons = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        ons[_i - 1] = arguments[_i];
    }
    var map = new Map();
    for (var _a = 0, ons_1 = ons; _a < ons_1.length; _a++) {
        var on_1 = ons_1[_a];
        for (var _b = 0, _c = on_1.types; _b < _c.length; _b++) {
            var type = _c[_b];
            map.set(type, on_1.reducer);
        }
    }
    return function (state, action) {
        if (state === void 0) { state = initialState; }
        var reducer = map.get(action.type);
        return reducer ? reducer(state, action) : state;
    };
}
